import getBasePath from '../functions/api-resource';
import empresa from '../functions/company';

const basePath = getBasePath('api', 'v1');

const CategoriaActions = {
    buscar: { method: 'GET', url: `${basePath}/departamentos?with=subdepartamentos&conexion=${empresa}` },
    buscarLojas: { method: 'GET', url: `${basePath}/{id}/lojas?conexion=${empresa}` },
    ativarMassa: { method: 'PUT', url: `${basePath}/ativacao-massa?conexion=${empresa}` },
    listarFiltrado: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}&conexion=${empresa}` },
    obter: { method: 'GET', url: `${basePath}/{codigo}?conexion=${empresa}` },
    listarPorRepresentante: { method: 'GET', url: `${basePath}/por-representante?indAtivo=true&conexion=${empresa}` },
    listarAutocomplete: { method: 'GET', url: `${basePath}?tamanhoPagina=6&numeroPagina=1&autocomplete={autocomplete}&indAtivo=true&conexion=${empresa}` },

};

export default resource => resource(`${basePath}`, {}, CategoriaActions);


// WEBPACK FOOTER //
// ./src/common/resources/departamento.js